import { CountryCode, LanguageCode } from '@shopify/hydrogen/storefront-api-types'
import { LanguageSwitchLink } from './language-switch-link.client'
import styles from '../../assets/scss/components/language/language-switch.module.scss'
import { classNames } from '@shopify/css-utilities'

export const LanguageSwitch: React.FC<{ isWhite?: boolean }> = ({ isWhite = false }) => {
  return (
    <div className={classNames(styles.languageSwitch, isWhite && styles.isWhite)}>
      <LanguageSwitchLink code="fr-fr" countryCode={CountryCode.Fr} languageCode={LanguageCode.Fr} title="france" />
      {' | '}
      <LanguageSwitchLink code="en-us" countryCode={CountryCode.Us} languageCode={LanguageCode.En} title="us" />
      {' | '}
      <LanguageSwitchLink code="en" countryCode={CountryCode.Fr} languageCode={LanguageCode.En} title="international" />
    </div>
  )
}
